document.querySelectorAll('.login-and-toolmenu').forEach(function(menu) {
  menu.addEventListener('click', function () {
    if (this.classList.contains('active')) {
      document.querySelectorAll('.login-and-toolmenu').forEach(function(el) {
        el.classList.remove('active');
      });
    } else {
      document.querySelectorAll('.login-and-toolmenu').forEach(function(el) {
        el.classList.add('active');
      });
    }
  }); 
});

// When click outside dropdown close
document.addEventListener('click', function(event) {
  if (!event.target.closest('.login-and-toolmenu')) {
    document.querySelectorAll('.login-and-toolmenu').forEach(function(el) {
      el.classList.remove('active');
    });
  }
});